(() => {
  const STORAGE_KEY = 'pc_breadcrumb_context';

  function saveContext(link) {
    if (!link) return;

    const productHandle = (link.dataset.productHandle || '').trim();
    if (!productHandle) return;

    const contextTitle = (link.dataset.breadcrumbSourceTitle || '').trim();
    const contextUrl = (link.dataset.breadcrumbSourceUrl || '').trim();

    try {
      sessionStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({
          productHandle,
          contextTitle,
          contextUrl,
          savedAt: Date.now()
        })
      );
    } catch (error) {
      console.warn('Breadcrumb context could not be saved.', error);
    }
  }

  document.addEventListener(
    'click',
    (event) => {
      const link = event.target.closest('a[data-product-handle]');
      if (!link) return;
      saveContext(link);
    },
    { capture: true }
  );

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter') return;
    const link = event.target.closest('a[data-product-handle]');
    if (!link) return;
    saveContext(link);
  });

  const breadcrumb = document.querySelector('.pc-breadcrumb[data-product-handle]');
  if (!breadcrumb) return;

  const currentProductHandle = breadcrumb.dataset.productHandle;
  const contextItem = breadcrumb.querySelector('.pc-breadcrumb__item--context');
  const contextLink = breadcrumb.querySelector('.js-pc-breadcrumb-context-link');

  if (!contextItem || !contextLink) return;

  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return;

    const data = JSON.parse(raw);
    if (!data || data.productHandle !== currentProductHandle) return;

    if (!data.contextTitle || !data.contextUrl) return;

    if (data.contextUrl === '/') {
      return;
    }

    contextLink.textContent = data.contextTitle;
    contextLink.href = data.contextUrl;
    contextItem.hidden = false;
  } catch (error) {
    console.warn('Breadcrumb context could not be restored.', error);
  }
})();